import map from 'lodash/map'
import React, { FC } from 'react'
import styled from 'styled-components'

import { PaymentIcon } from '@Components/Payment/PaymentIcon'
import { PaymentMethod } from '@Globals/Metadata'

const StyledPaymentIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > div {
    margin-right: 5px;
    margin-bottom: 5px;
  }
`

export const PaymentIcons: FC<Pick<PaymentMethod, 'icons'>> = ({ icons }) => (
  <StyledPaymentIcons>
    {map(icons, icon => <PaymentIcon key={icon.name} name={icon.name} url={icon.url} />)}
  </StyledPaymentIcons>
)
